<template>
    <div class="col-lg-12 col-xl-6 column">

        <div class="graph-panel graph-panel-1 sameHeight" data-height="height">

            <div class="box-inner">

                <div class="row">

                    <div class="col-sm-12 text-right">
                        <a class="btn btn-default dyk" data-toggle="modal" v-bind:data-target="graphModalId" title="About this question">
                            <i class="far fa-lightbulb"></i>
                        </a>
                    </div>

                    <div class="col-sm-12 text-left">
                        <h2>{{title}}</h2>
                    </div>

                </div>

                <p v-html="description"></p>

                <div class="chart-protector">

                    <div class="chart-wrapper">
                        <apexcharts type="bar" :options="chartDetails.options" :series="chartDetails.series"></apexcharts>
                    </div>

                    <div v-show="showMM" class="mandmoverlay">
                        <h4>All Data:</h4>
                        <span>Median: {{medianValueOrig}}</span><br />
                        <span>IQR: {{IQRValueOrig}}</span>
                        
                        <br />
                        <br />

                        <h4>Filtered:</h4>
                        <span>Median: {{medianValueFiltered}}</span><br />
                        <span>IQR: {{IQRValueFiltered}}</span>
                        

                        <span class="btn btn-primary" v-on:click="showMM = !showMM">Close</span>
                    </div>

                </div>

                 <p>{{noAnswer}} people who did not answer the question are excluded from this analysis<br />
                {{noAnswerFiltered}} people who did not answer the question are excluded from the filtered analysis
                </p>
                
            </div>

            <div class="blurred-box"></div>

        </div>
        
    </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
    components: {
        apexcharts: VueApexCharts
    },
    props: [
        'originalData',
        'filteredData',
        'chartId',
        'categories',
        'title',
        'description',
        'graphModalId',
        'originalDataCount',
        'hasMedian',
        'noAnswer',
        'noAnswerFiltered',
        'xAxisTitle',
        'customMedianIQR',
        'customMedianIQRFiltered',
    ],
    data() {
        return {
            chartDetails: {
                 options: {
                    chart: {
                        id: this.chartId,
                        toolbar: {
                            show: true,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: true,
                                customIcons: [],
                            },
                            export: {
                                csv: {
                                    filename: undefined,
                                    columnDelimiter: ',',
                                    headerCategory: 'category',
                                    headerValue: 'value',
                                    dateFormatter(timestamp) {
                                        return new Date(timestamp).toDateString()
                                    }
                                },
                                svg: {
                                    filename: undefined,
                                },
                                png: {
                                    filename: undefined,
                                }
                            },
                            autoSelected: 'zoom' 
                        },
                        stacked: false
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            barHeight: '50%',
                            borderRadius: 6,
                            dataLabels: {
                                position: 'top'
                            }
                        }
                    },
                    xaxis: {
                        categories: this.categories,
                        labels: {
                            style: {
                                colors: ['#333333'],
                                fontSize: '12px',
                                fontWeight: 'bold',
                                fontFamily: 'Quicksand, Arial, sans-serif'
                            }
                        },
                        
                        title: {
                            text: this.xAxisTitle,
                            offsetY: -5,
                            style: {
                                cssClass: 'apexcharts-xaxis-title',
                            },
                        },
                    },
                    yaxis: {
                        labels: {
                            style: {
                                colors: ['#333333'],
                                fontSize: '12px',
                                fontWeight: 'bold',
                                fontFamily: 'Quicksand, Arial, sans-serif'
                            },
                            align: 'left',
                            formatter: function(val) {
                                return val + '%';
                            }
                        },
                        title: {
                            text: 'Percentage of participants',
                        },
                        max: 100,
                    },
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: this.ChartFormatter
                        }
                    },
                    grid: {
                        show: false
                    },
                    colors: ['#9BB0D3','#50AB68'],
                    dataLabels: {
                        enabled: true,
                        style: {
                            colors: ['#333333'],
                            fontSize: '12px',
                            fontWeight: 'bold',
                            fontFamily: 'Quicksand, Arial, sans-serif'
                        },
                        textAnchor: 'middle',
                        offsetY: -20,
                        formatter: this.ChartFormatterPercentOnly
                    },
                    responsive: [{
                        breakpoint: 1000,
                        options: {
                            yaxis: {
                                labels: {
                                    align: 'left',
                                    formatter: function(val) {
                                        return val + '%';
                                    }
                                },
                                max: 100
                            }
                        }
                    }]
                },
                series: [{
                    name: 'All Natsal-3 participants',
                    data: this.originalData
                },
                {
                    name: 'Your filter',
                    data: this.filteredData
                }]
            },
            showMM: false,
            // meanValueOrig: 0,
            medianValueOrig: 0,
            //meanValueFiltered: 0,
            medianValueFiltered: 0,
            IQRValueOrig: 0,
            IQRValueFiltered: 0,
            underThreshold: false,
            lowestThresold: 0.2,
            totalValues: [],
            totalValuesFiltered: []
        }
    },
    methods: {
        ChartFormatter(val, opts) { // opts
            if (val == 0 || isNaN(val)) {
                return "";
            }
            else {
                var output = "";
                if (val <= 0.2) {
                    output = "<0.2%";
                }
                else {
                    output = val + '%';
                }

                if (opts.seriesIndex == 0) {
                    return output + ' (' + this.totalValues[opts.dataPointIndex] + ")";
                }
                else { //if (opts.seriesIndex == 0){
                    return output + ' (' + this.totalValuesFiltered[opts.dataPointIndex] + ")";
                }
                // var percent = ((val /  this.originalDataCount) * 100).toFixed(1);

                // if (percent < this.lowestThresold) {
                //     return "<0.2%";
                // }
                // else {
                //     return val + " (" + percent + "%)";
                // }
            }
        },
        ChartFormatterPercentOnly(val) { // opts
            if (val == 0 || isNaN(val)) {
                return "";
            } 
            else {
                if (val <= 0.2) {
                    return "<0.2%";
                }
                else {
                    return val + '%';
                }

                // var percent = ((val / this.originalDataCount) * 100).toFixed(1);

                // if (percent < this.lowestThresold) {
                //     return "<0.2%";
                // }
                // else {
                //     return percent + "%";
                // }
            }
        },
        // GetMeanValue(arr) {
        //     var total = 0;

        //     for (let i = 0; i < arr.length; i++) {
        //         total += arr[i];
        //     }

        //     return (total / arr.length).toFixed(1);
        // },
        GetMedianValue(arr) {
            var mappedArray = arr.map(x => x);

            mappedArray.sort(function(a,b){
                return a-b;
            });

            var half = Math.floor(mappedArray.length / 2);
            
            if (mappedArray.length % 2 == 0)
                return parseInt(mappedArray[half]);
            
            return (parseInt(mappedArray[half - 1]) + parseInt(mappedArray[half])) / 2.0;
        },
        GetIQRValue(arr) {
            var tmpArray = [];

             for (let i = 0; i < arr.length; i++) {
                 if (arr[i] != '') {
                     tmpArray.push(parseInt(arr[i]));
                 }
            }

            tmpArray.sort(function(a, b) { return a - b});

            var lowerMedian = 0;
            var higherMedian = 0;
            var idx = 0;
            var tmpArrQ1 = [];
            var tmpArrQ3 = [];

            if (tmpArray.length % 2 == 1) { // Odd count ignore median
                idx = Math.floor(tmpArray.length / 2);
            }
            else {
                idx = tmpArray.length / 2;
            }

            for (let i = 0; i < idx; i++) {
                tmpArrQ1.push(tmpArray[i]);
            }

            if (tmpArray.length % 2 == 1) {
                idx += 1;
            }

            for (let i = idx; i < tmpArray.length; i++) {
                tmpArrQ3.push(tmpArray[i]);
            }

            lowerMedian = this.GetMedianValue(tmpArrQ1);
            higherMedian = this.GetMedianValue(tmpArrQ3);

            return Math.round(higherMedian - lowerMedian);
        },
        MedianOverlay() {
            this.showMM = !this.showMM;
        },
        GetPercentageValues(arr, count) {
            var newArr = [];
            for (let i = 0; i < arr.length; i++) {
                newArr.push(((arr[i] / count) * 100).toFixed(0));
            }

            return newArr;
        }
    },
    computed: {
        originalCount() {
            var count = 0;

            for (var i = 0; i < this.originalData.length; i++) {
                count += this.originalData[i];
            }

            return count;
        },
        filteredCount() {
            var count = 0;

            for (var i = 0; i < this.filteredData.length; i++) {
                count += this.filteredData[i];
            }

            return count;
        }
    },
    watch: {
        originalData(newData) {
            this.totalValues = newData;
            this.chartDetails.series[0].data = this.GetPercentageValues(newData, this.originalCount);

            if (this.hasMedian) {
                //this.meanValueOrig = this.GetMeanValue(newData);

                if (this.customMedianIQR != null && this.customMedianIQR != []) {
                    this.medianValueOrig = this.GetMedianValue(this.customMedianIQR);
                    this.IQRValueOrig = this.GetIQRValue(this.customMedianIQR);
                }
                else {
                    this.medianValueOrig = this.GetMedianValue(newData);
                    this.IQRValueOrig = this.GetIQRValue(newData);
                }
            }
        },
        filteredData(newData) {
            this.underThreshold = false;

            this.totalValuesFiltered = newData;
            this.chartDetails.series[1].data = this.GetPercentageValues(newData, this.filteredCount);

            if (this.hasMedian) {
                //this.meanValueFiltered = this.GetMeanValue(newData);
                
                if (this.customMedianIQRFiltered != null && this.customMedianIQRFiltered != []) {
                    this.medianValueFiltered = this.GetMedianValue(this.customMedianIQRFiltered);
                    this.IQRValueFiltered = this.GetIQRValue(this.customMedianIQRFiltered);
                }
                else {
                    this.medianValueFiltered = this.GetMedianValue(newData);
                    this.IQRValueFiltered = this.GetIQRValue(newData);
                }
            }

            //
            for (let i = 0; i < newData.length; i++) {
                 var percent = ((newData[i] / this.filteredCount) * 100).toFixed(0);

                if (percent < this.lowestThresold) {
                    this.underThreshold = true;
                    break;
                }
            }
        }
    },
    mounted: function() {
        if (this.hasMedian == "true") {
            this.chartDetails.options.chart.toolbar.tools.customIcons = [{
                icon: '<i class="fas fa-list-ul ml15" v-on:click="showMM = !showMM"></i>',
                index: 1,
                title: 'Extra stats',
                class: 'custom-icon',
                click: this.MedianOverlay
            }];
        }
    }
}
</script>

<style>

</style>